import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { ScheduleLesson } from '../../../interfaces/schedule';
import { LocationSelectPickerComponent } from '../../location-select-picker/location-select-picker.component';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

@Component({
  selector: 'app-schedule-lesson',
  templateUrl: './schedule-lesson.component.html',
  styleUrls: ['./schedule-lesson.component.scss']
})
export class ScheduleLessonComponent {
  @Input() onlineClassText: string = 'מקוון';
  @Input() cancelledClassText: string = 'השיעור בוטל';
  @Input() hibridClassText: string = 'היברידי';
  @Input({ required: true }) lesson!: ScheduleLesson;
  @HostBinding('style.--lesson-size') get size() {
    const size = this.lesson.timeEnd - this.lesson.timeStart;

    return size > 1 ? size : 1;
  };
  @HostBinding('class.single-lesson') @Input() single: boolean = true;
  @HostBinding('class.single-height') get heightClass() {
    return this.lesson.timeEnd - this.lesson.timeStart <= 1;
  };
  @Input() spaceBefore: number = 0;
  //@HostBinding('style.--lesson-top-margin') @Input() spaceBefore: number = 0;
  @HostBinding('style.--lesson-top-margin') get topMargin() {
    return this.userAgentService.isMobileDevice() ? 0 : this.spaceBefore;
  }

  @ViewChild('locatinPicker') locatinPicker!: LocationSelectPickerComponent;

  constructor(private userAgentService: UserAgentService){ }
}
